import styled from 'styled-components'
import { COLORS } from '../../constants'

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 7vh;
  background-color: ${COLORS.primary};
`

export const Text = styled.p`
  font-size: 1.5rem;
  color: white;
  margin-left: 20px;
  line-height: 1.8rem;
`

export const LeftDiv = styled.div`
  width: 30%;
  display: flex;
  justify-content: start;
  align-items: center;
`

export const RightDiv = styled.div`
  width: 70%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const BrandName = styled.p`
  font-size: 2rem;
  color: ${COLORS.darkGray};
  margin-right: 70px;
  font-weight: bold;
  text-transform: uppercase;
`
